// extracted by mini-css-extract-plugin
export var aiStarIcon = "_l6-2";
export var container = "_l6-4";
export var dismissButton = "_l6-3";
export var hasPaddingBottom = "_l6-6";
export var last = "_l6-e";
export var scrollbarThumb = "_l6-c";
export var scrollbarTrack = "_l6-b";
export var selected = "_l6-9";
export var spin = "_l6-1";
export var spinning = "_l6-0";
export var suggestionItem = "_l6-d";
export var suggestionsPanel = "_l6-5";
export var tonePill = "_l6-8";
export var tonesContainer = "_l6-7";
export var unselected = "_l6-a";